import React, { useState, useEffect,useRef } from "react";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import useUploadHook from "components/uploadHook";
import FilterSelect from "components/Form/filterSelect";
import {  toast, Bounce } from 'react-toastify';
import { useDropzone } from 'react-dropzone';

import { useSelector } from "react-redux";
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Button } from "components/Button";
import {Switch} from "antd";
import {format} from "date-fns"
import {  Modal } from 'antd';
import { postUniformApi, updateUniformApi } from "api/services/uniforms";
import ViewUniformAttachments from "views/pages/Uniforms/uniformDetail/attachmentHandler";
import { activeStatusOptions } from "utils/constants";
import UniformPosition from "views/pages/Uniforms/uniformDetail/uniformDepartment";
import EssFullWidthModal from "components/modelpopup/baseModal"


const AllUniformAddPopup = ({ uniformModal, setUniformModal, loading, selectedUniform, setLoading, setSelectedUniform, getUniformList, reloadPage}) => {
  const modalRef = useRef()
  


const [uniformSizeOption, setUniformSizeOption] = useState([]);
const [positionOption, setPositionOption] = useState([]);
const [genderOption, setGenderOption] = useState([]);
const [uniformDepartment, setUniformDepartment] = useState([]);
const [fileUploadLoading, setFileUploadLoading] = useState(false);

  
  const {  
    uniformSizes, uniformSizesLoading,
    department, departmentLoading,
    position, positionLoading
    //userData, userDataLoading   
} = useSelector((state) => state.common);

const {
  uploadLoading,
  handleFile
} = useUploadHook()

const uniformRequestSchema = Yup.object().shape({
  name: Yup.string().required('Uniform name is required'), 
  description: Yup.string(),  
  positions: Yup.array().of(Yup.object()).nullable(),
  sizes: Yup.array().of(Yup.object()).nullable(),  
  gender: Yup.object().shape({
    label: Yup.string().required(),
    value: Yup.string().required(),
  }).nullable().required("Gender is required"),
  status: Yup.boolean().required("Status is required"),
  image: Yup.string().required('Uniform Image is required'), 

});



const {
  control,
  handleSubmit,
  formState: { errors },
  getValues,
  watch,
  setValue,
  setError,
  reset  ,
  register
} = useForm({
  resolver: yupResolver(uniformRequestSchema), 
  defaultValues: {
    name: "",
    description: "",
    gender: null,
    status: null,
    sizes: [],
    // department: [],
    // uniformDepartment:[]
  }
});

// const { fields: attachmentFields, append: appendAttachment, remove: removeAttachment } = useFieldArray({
//   control,
//   name: "attachments",
// });

const { fields: departmentFields, append: appendDepartment, remove: removeDepartment } = useFieldArray({
  control,
  name: "positions",
});





useEffect(()=>{   
  const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
  

  if(uniformSizes){
    let _sizes = [...uniformSizes];

    _sizes.sort((a, b) => sizeOrder.indexOf(a.code) - sizeOrder.indexOf(b.code));
    let sizes = _sizes.map(item=> {
      return{
          label: item.code,
          value: item.id
      }
  })
  setUniformSizeOption(sizes)

  let gender = [
    {label:"Male", value:"M"},
    {label:"Female", value:"F"},
    {label:"Unisex", value:"U"}]
    setGenderOption(gender)
  }
},[uniformSizes])


  useEffect(() => {
    if (position) {
      let _positions = position.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setPositionOption(_positions);
    }
  }, [department]);


useEffect(()=>{

  if(selectedUniform?.id){
    setValue("name", selectedUniform?.name)
    setValue("description", selectedUniform?.description)
    setValue("image", selectedUniform?.image)

    if(selectedUniform?.sizes) {
      setValue("sizes", uniformSizeOption.filter(option => 
      selectedUniform.sizes.some(size => size.id === option.value)
     ));}

     console.log(selectedUniform, "unnniifooormmm")



        setValue("positions", selectedUniform?.uniform_positions?.map(item=> {
          return {
            ...item,
            position: item.position?.id

          }
        }))
   
     if(selectedUniform?.gender) {   
        setValue("gender", genderOption.find(item=> item.value == selectedUniform?.gender))
    }
   
    // if(selectedUniform?.status) {      
    //   setValue("status", activeStatusOptions.find(item=> item.value == selectedUniform?.status))
    // }    
    setValue("status", selectedUniform?.status)


    console.log(selectedUniform, "---SLECETED COLOOOR")

  }
},[selectedUniform, uniformModal])

 
 

const fileUploadHandler = async(acceptedFiles , rejectedFiles , e ) => {
    console.log(e.target.files, "EEEE")
    let attachments = []
    const urls = await handleFile(e);
    if(Array.isArray(urls)){
       attachments = urls.map(item=>{return{url: item}})
    }else{
      attachments.push({
        url:urls
      })
    }
    // console.log(attachmentFields, "LLLL")

    setValue("image", urls)
   }
 // Use Dropzone hook
 const { getRootProps, getInputProps } = useDropzone({
  onDrop: fileUploadHandler,

  accept: 'image/*', // Accept image, PDF, DOCX
});

const  onSubmit = (data) =>{
    console.log(data, "LLLLL")
    let formData = {}
    // formData['name'] = data?.name;
    // formData['description'] = data?.description;
    data['gender'] = data?.gender?.value;
    data['sizes'] =  data.sizes?.map(item => item.value);
    // let attachments_data = data['attachments'].map(item=>{
    //   return{
    //     id: item.item_id||"",
    //     url: item.url
    //   }
    // })
    // formData['attachments'] = {}

    console.log(data,"----formData")

    // reset()
    // data['department'] = data?.department?.value
    // data['status'] = data?.status?.value
  
    setLoading(true)

    if(selectedUniform?.id){
      updateUniformApi(selectedUniform?.id, data).then(response=>{
        setLoading(false)
  
        toast.success('Uniform updated!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setUniformModal(false)
          reloadPage()
          setSelectedUniform("")
          reset()
  
        console.log(response, "REEEEEE")
      }).catch(e=> {
        setLoading(false)

        try{
          console.log(e.response.data, "EEEEE")
          if(e.response.data){
            Object.entries(e.response.data).forEach(([k, v]) => {
              console.log(typeof v, "EEEEE")
              setError(k,
                {
                  type: 'manual',
                  message: v.join(", ")
                }
                 )
            })
          }
        }catch(e){
          toast.error('Failed to create uniform!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
  
       
      })

    }else{
      postUniformApi(data).then(response=>{
        setLoading(false)
        getUniformList()
  
        toast.success('Uniform created!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setUniformModal(false)
          reloadPage()
          setSelectedUniform("")
          reset()
  
        console.log(response, "REEEEEE")
      }).catch(e=> {
        console.log(e, "eee")
        setLoading(false)
        try{
          console.log(e.response.data, "EEEEE")
        if(e.response.data){
          Object.entries(e.response.data).forEach(([k, v]) => {
            console.log(typeof v, "EEEEE")
            setError(k,
              {
                type: 'manual',
                message: v.join(", ")
              }
               )
          })
        }
        }catch(e){
          toast.error('Failed to create uniform!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
  
        
      })
    }

   
    // createUniformHandler(data, setError, modalRef, reset)
    // setError('status', { type: 'custom', message: 'custom message' });

    // setError("status", "status errrr")
  }
 


  const removeAttachment = () => {
    setValue("image", "")
  }
  let selectedImage = watch("image")

  let watchDept = watch("positions")


return (
    <>
      <div role="dialog">      
      <EssFullWidthModal
        mask={false}
              title={selectedUniform?.id ? "Update Uniform":"Add Uniform"}
              // style={{ top: 100 }}
              open={uniformModal}
              width={"40%"}
              footer={[]}     
              onCancel={() => {
                setUniformModal(false)
                setSelectedUniform("")
              }}
                className="full-width-modal"


            >
          <div className="modal-content">
            
            <div className="modal-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    {/* Uniform Name */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Name</label>
                       <Controller
                              name="name"
                              control={control}                      
                              render={({ field }) => (
                                <input className="form-control"  value={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                                type="text"
                                placeholder="Uniform Name"
                                />                    
                         )}
                  />
                    {errors.name && <small className="text-danger">{errors.name?.message}</small>}
                    </div>
                  </div>
                    {/* Description */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Description</label>
                      <Controller
                        name="description"
                        control={control}                      
                        render={({ field }) => (
                          <input className="form-control"  value={field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                          type="text"
                          placeholder="Description"
                          />
                    )}
                  />
           

                      
                    </div>
                  </div>
                </div>
               
                
                
                <div className="row">
                 {/* Uniform Size */}
                  <div className="col-md-6">
                  <div className="input-block mb-3">
                      <label className="col-form-label">Uniform Size</label>
                      <Controller
                         name={`sizes`}                   
                         control={control}                  
                         render={({ field: { value, onChange } }) => (
                          <>
                   
                          <FilterSelect
                        {...register("sizes")}
                        isClearable={true}
                        isMulti
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={uniformSizeOption}
                        isLoading={false}
                        value={value}
                        placeholder={"Select Size"}
                      />                       
                      </>
                    )}
                  />
                  {
                    console.log(errors, "EEEEEEEE")
                  }
               
                  {errors.size && <small className="text-danger">{errors.size?.message}</small>}                     
                  </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Gender</label>
                      <Controller
                        name={`gender`}                      
                        control={control}                      
                        render={({ field: { value, onChange } }) => (
                          <>
                            <FilterSelect
                              {...register("gender")}
                              isClearable={true}                             
                              onChange={onChange}
                              optionLabel={"label"}
                              optionValue={"value"}
                              options={genderOption}
                              isLoading={false}
                              value={value}
                              placeholder={"Select Gender"}
                            /> 
                          </>
                        )}
                      />
                      {errors.gender && (
                        <small className="text-danger">
                          {errors.gender?.message}
                        </small>
                      )}
                    </div>
                </div> 
                      
                </div>   


                <div className="row">
                <div className="col-md-12">

                    {/* Uniform Department */}
                    <UniformPosition register={register} append={appendDepartment} remove={removeDepartment} positionOptions={positionOption} data={watchDept} control={control} errors={errors} />
                    </div>
                  
                </div>
                <div className="row mt-4">             

                    <div className="col-md-6">
                    <div className="input-block mb-3">
                    <label className="col-form-label">Status</label>

                    <Controller
                            name="status"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                              <div className="d-flex align-items-center">
                                <Switch 
                                  checked={value} 
                                  onChange={onChange} 
                                  onColor="#0d6efd" 
                                  offColor="#ccc"
                                  // checkedIcon={<div style={{ padding: 5 }}>Active</div>}
                                  // uncheckedIcon={<div style={{ padding: 5 }}>Inactive</div>}
                                />
                                {/* <span className="ms-2">{value ? "Active" : "Inactive"}</span> */}
                              </div>
                            )}
                          />

                      {console.log(errors, "EEEEEEEE")}
                      {errors.status && (
                        <small className="text-danger">
                          {errors.status?.message}
                        </small>
                      )}
                    </div>
                  </div>

                </div>    

         
               {/* Attachments */}               
                <div className="row">
                  <div className="col-md-6">
                  <div className="input-block mb-3">

                  <label className="col-form-label">Image {
                    uploadLoading && <i class="fa fa-spinner fa-spin" ></i>
                  }</label>
                  {/* <input
                    type="file"
                    className="form-control"
                    id="cv_upload"                 
                    onChange={fileUploadHandler}
                    disabled={uploadLoading}                    
                  /> */}
                  <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <input {...getInputProps()} />
                      <p>Drag & Drop your files here, or click to select files</p>
                    </div>

                  <p className="text-danger mb-2">
                    {errors?.image?.message}
                  </p>
                  
                </div>

                <div className="col-12" >
                <ViewUniformAttachments fields={selectedImage? [{url:selectedImage}]: []} remove={removeAttachment}  />
                </div>



                  </div>

                  
                </div>

               
                
                
                <div className="submit-section">
                  <Button
                  loading={loading}
                  disabled={loading || uploadLoading}
                    className="btn btn-primary submit-btn"             
                    type="submit"
                    label="Submit"
                  />
                   
                </div>
              </form>
            </div>
          </div>
          </EssFullWidthModal>
      </div>
    </>
  );
};

export default AllUniformAddPopup;
